import { Component, ElementRef, Input, Output, EventEmitter, OnChanges, SimpleChange, SimpleChanges, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { EventService } from '../../services/event.service';

@Component({
  selector: 'icc-button',
  templateUrl: './icc-button.component.html',
  styleUrls: ['./icc-button.component.less'],
})
export class IccButtonComponent implements OnInit, OnChanges, OnDestroy {
  constructor(public http: _HttpClient, private el: ElementRef, private event: EventService, private cdr: ChangeDetectorRef) {}
  @Input() isLoading: boolean; // http的请求状态
  @Input() isDisabled = false;
  @Input() btnType = 'default';
  @Output() btnClick: EventEmitter<any> = new EventEmitter<any>();

  // 按钮最终是否显示加载状态
  btnLoading: boolean = false;
  // 是否点击了该按钮
  hasClick: boolean;

  // 是否手动监听http的请求状态；false: 使用ngOnchanges钩子监听输入
  isHandMonitor = true;
  // 订阅事件名
  _HTTP_LOADING_EVENT_NAME = 'http-loading-change';
  // http等待时长, 默认超过3秒可以重新请求
  waittingTime = 3000;
  startTime = 0;

  limitTimeout: any;

  btnTypes = {
    default: {
      fillColor: '#37ba9d',
      borderColor: '#37ba9d',
      textColor: '#ffffff',
      hover: {
        fillColor: '#45c9ac',
        borderColor: '#45c9ac',
        textColor: '#ffffff',
      },
    },
    danger: {
      fillColor: '#f46f6c',
      borderColor: '#f46f6c',
      textColor: '#ffffff',
      hover: {
        fillColor: '#f77f7',
        borderColor: '#f77f7',
        textColor: '#ffffff',
      },
    },
    hollow: {
      fillColor: '#ffffff',
      borderColor: '#eaecf0',
      textColor: '#49536e',
      hover: {
        fillColor: '#ffffff',
        borderColor: '#37ba9d',
        textColor: '#37ba9d',
      },
    },
    disabled: {
      fillColor: '#ededed',
      borderColor: '#d9d9d9',
      textColor: 'rgba(0,0,0,.25)',
    },
    dangerHollow: {
      fillColor: '#FBEBEB',
      borderColor: '#f46f6c',
      textColor: '#f46f6c',
      hover: {
        fillColor: '#FBEBEB',
        borderColor: '#f77f7',
        textColor: '#f77f7',
      },
    },
  };

  ngOnInit() {
    this.event.deleteAttr(this._HTTP_LOADING_EVENT_NAME);
  }

  ngOnChanges(changes: any) {
    // if (changes.isLoading && changes.isLoading.firstChange) {
    //   this.isHandMonitor = false;
    // }
    if (changes.isLoading && this.hasClick) {
      this.btnLoading = this.isLoading;
      if (!this.isLoading) {
        this.hasClick = false;
        this.event.deleteAttr(this._HTTP_LOADING_EVENT_NAME);
      }
    }
  }

  ngOnDestroy() {
    this.event.deleteAttr(this._HTTP_LOADING_EVENT_NAME);
    if (this.limitTimeout) {
      clearTimeout(this.limitTimeout);
      this.limitTimeout = null;
    }
  }

  handleClick(evt) {
    let hasResponse = false;
    if (!this.btnLoading) {
      if (this.isHandMonitor) {
        this.limitHttpTimes();
        // 事件订阅
        this.event.deleteAttr(this._HTTP_LOADING_EVENT_NAME);
        this.event.addWatcher(this._HTTP_LOADING_EVENT_NAME, __loading => {
          const isSame = !!this.isLoading === !!__loading;
          if (!isSame) {
            this.isLoading = Boolean(__loading);
            if (__loading === 0) {
              this.isLoading = true;
            }
            this.ngOnChanges({ isLoading: true });
            this.cdr.detectChanges();
          }
          hasResponse = true;
        });
      }
      this.btnClick.emit();
      hasResponse = false;
      this.hasClick = true;

      // 如果事件触发1000ms后，订阅的事件没有响应，那么表示此次按钮点击，不会触发请求，则将hasClick = false;
      setTimeout(() => {
        if (!hasResponse) {
          this.hasClick = false;
        }
      }, 1000);
    }
  }
  limitHttpTimes() {
    this.startTime = new Date().getTime();
    if (this.limitTimeout) {
      clearTimeout(this.limitTimeout);
      this.limitTimeout = null;
    }
    this.limitTimeout = setTimeout(() => {
      if (this.btnLoading) {
        this.btnLoading = false;
      }
      this.cdr.detectChanges();
    }, this.waittingTime);
  }
  handleMouseover() {
    this.changeState('hover');
  }
  handleMouseleave() {
    this.changeState('default');
  }
  changeState(state: string) {
    if (state === 'default') {
      this.el.nativeElement.children[0].style.backgroundColor = this.btnTypes[this.btnType].fillColor;
      this.el.nativeElement.children[0].style.borderColor = this.btnTypes[this.btnType].borderColor;
      this.el.nativeElement.children[0].style.color = this.btnTypes[this.btnType].textColor;
    } else if (state === 'hover') {
      this.el.nativeElement.children[0].style.backgroundColor = this.btnTypes[this.btnType].hover.fillColor;
      this.el.nativeElement.children[0].style.borderColor = this.btnTypes[this.btnType].hover.borderColor;
      this.el.nativeElement.children[0].style.color = this.btnTypes[this.btnType].hover.textColor;
    }
  }
}
